import React from 'react';

const FacebookIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "14",
    height: "25",
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.8506 14.1996L13.5256 9.99953H9.55059V7.07448C9.55059 5.87446 10.0006 4.97444 11.8006 4.97444H13.7506V1.14937C12.7006 0.999368 11.5006 0.849365 10.4506 0.849365C7.00059 0.849365 4.60059 2.9494 4.60059 6.69947V9.99953H0.850586V14.1996H4.60059V24.7748C5.42559 24.9248 6.25059 24.9998 7.07559 24.9998C7.90059 24.9998 8.72559 24.9248 9.55059 24.7748V14.1996H12.8506Z",
      fill: "white"
    }
  )
);
FacebookIcon.displayName = "Icons.FacebookIcon";

export { FacebookIcon };
//# sourceMappingURL=FacebookIcon.js.map
